import { ChangeEvent, FunctionComponent } from 'react';

import { CheckboxItem } from '.';
import { CheckboxListType } from '../../types';
import { getIn } from 'formik';
import { useTranslation } from 'react-i18next';

const CheckboxList: FunctionComponent<CheckboxListType> = ({
  formikProps,
  label,
  name,
  tooltipIcon,
  required = false,
  dangerOnSelect = false,
  dangerOnDeselect = false,
  headers = [],
  options = [],
  columnSizes = [],
  checkAll = false,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <div className={'responsive-spacing'}>
      {headers && (
        <CheckboxItem
          formikProps={formikProps}
          label={label}
          name={`checkAll`}
          key={`${name}-header`}
          title={getIn(formikProps.values, 'checkAll') ? t('label.desselecionar_todos') : t('label.selecionar_todos')}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            const values = { ...formikProps.values };
            Object.keys(formikProps.values).forEach((key) => (values[key] = event.target.checked));
            formikProps.setValues({ ...values });
          }}
          labels={headers}
          columnSizes={columnSizes}
          header
          {...props}
        />
      )}
      <ul className={`list-group list-scrollable with-header`} key={'list'}>
        {options?.map((option) => {
          return (
            <CheckboxItem
              formikProps={formikProps}
              label={option.labels[0]}
              name={option.id.toString()}
              key={`checkbox-item-${option.id}`}
              labels={option.labels}
              columnSizes={columnSizes}
              tooltip={option.tooltip}
              tooltipIcon={tooltipIcon}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                formikProps.setValues({
                  ...formikProps.values,
                  [option.id]: event.target.checked,
                });
              }}
              highlight={!formikProps.values[option?.id] && option.highlight}
              dangerOnSelect={dangerOnSelect}
              dangerOnDeselect={!formikProps.values[option?.id] && formikProps.initialValues[option?.id] && dangerOnDeselect}
              {...props}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default CheckboxList;
